import Image from "next/image";

const SingleBlogImage = ({thumbnail, title}) => {
  return (
    <div className="relative w-full ">
      {thumbnail && (
        <Image
          src={thumbnail}
          width={1000}
          height={1000}
          alt={title}
          className="w-full h-auto object-contain relative z-[1] rounded-lg"
          priority
        />
      )}
    </div>
  );
};

export default SingleBlogImage;
